(() => {
  const initializeSlider = (slider) => {
    const track = slider.querySelector('[data-slider-track]');
    const slides = Array.from(slider.querySelectorAll('[data-slider-slide]'));
    const root = slider.closest('[data-product-card], [data-product-root], section') || slider.parentElement;
    const dots = root ? Array.from(root.querySelectorAll('[data-slider-dots] [data-slide-index]')) : [];
    const prevButton = slider.querySelector('[data-slider-prev]');
    const nextButton = slider.querySelector('[data-slider-next]');

    if (!track || slides.length < 2) {
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      return;
    }

    const currentIndex = () => {
      const width = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    };

    const goTo = (index) => {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    };

    const sync = () => {
      const index = currentIndex();
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === slides.length - 1;
    };

    sync();

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        sync();
        ticking = false;
      });
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(Number(dot.dataset.slideIndex || 0));
      });
    });

    if (prevButton) prevButton.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextButton) nextButton.addEventListener('click', () => goTo(currentIndex() + 1));

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(currentIndex() - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex() + 1);
      }
    });

    let pointerStartX = null;
    let dragged = false;
    track.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      dragged = false;
    });
    track.addEventListener('pointermove', (event) => {
      if (pointerStartX !== null && Math.abs(event.clientX - pointerStartX) > 8) dragged = true;
    });
    track.addEventListener('pointerup', () => { pointerStartX = null; });
    track.addEventListener('pointercancel', () => { pointerStartX = null; });

    const mediaLink = slider.closest('a');
    if (mediaLink) {
      mediaLink.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          dragged = false;
        }
      });
    }
  };

  const initializeProductForm = (root) => {
    const form = root.querySelector('.product-form');
    const variantSelect = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const submit = root.querySelector('[data-add-to-cart]');
    const radios = Array.from(root.querySelectorAll('[data-option-value]'));

    if (!form || !variantSelect || radios.length === 0) return;

    const getSelectedOptions = () => {
      const groups = Array.from(root.querySelectorAll('[data-option-position]'));
      return groups.map((group) => {
        const checked = group.querySelector('[data-option-value]:checked');
        return checked ? checked.value : '';
      });
    };

    const updateVariant = () => {
      const selectedOptions = getSelectedOptions();
      const matchingOption = Array.from(variantSelect.options).find((option) => {
        try {
          const optionValues = JSON.parse(option.dataset.options || '[]');
          return optionValues.every((value, index) => value === selectedOptions[index]);
        } catch (error) {
          return false;
        }
      });

      if (!matchingOption) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        return;
      }

      variantSelect.value = matchingOption.value;
      const available = matchingOption.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Add to cart' : 'Sold out';
      if (price && matchingOption.dataset.price) price.textContent = matchingOption.dataset.price;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingOption.value);
      window.history.replaceState({}, '', url.toString());
    };

    radios.forEach((radio) => radio.addEventListener('change', updateVariant));
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-media-slider]').forEach(initializeSlider);
    scope.querySelectorAll('[data-product-root]').forEach(initializeProductForm);
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
